import React from 'react';
import Select from './Select';
import { getRegional } from '../../../utils/storage';
import { propTypes } from './constants';

SelectRegion.propTypes = propTypes;
function SelectRegion({
  onChange,
  value,
  eventName,
  icon,
  inputProps,
  hideLabel,
  input,
}) {
  const regions = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];

  const region = getRegional();

  return (
    <Select
      data={[
        { value: '', name: 'Semua Region' },
        ...regions.map((r) => ({ value: r, name: r })),
      ]}
      eventName={eventName ?? 'filter_by_region'}
      hideLabel={hideLabel}
      icon={icon}
      input={input}
      inputProps={inputProps}
      onChange={(event) => onChange(event)}
      value={region ? region : value}
    />
  );
}
// { disabled: Boolean(region) }

export default SelectRegion;
